import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export interface IBrandResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.BRAND;
    title: string;
    contactEmail: string;
    primaryColor?: string;
    secondaryColor?: string;
    logo?: string;
}

export const isBrandResource = (resource: IHydraResource): resource is IBrandResource => {
    return resource["@type"] === EntityTypes.BRAND;
};
